import { forEach } from 'lodash-es'
import { processTextJson } from './text-response-helpers'

export function processAssets (assets) {
  var assetArr = []

  forEach(assets, function (asset, key) {
    // mainly for processing legacy json
    if (shouldProcessTextJson(asset)) {
      asset.responses = processTextJson(asset.responses)
    }
    assetArr.push([key, asset])
  })

  return assetArr
}

export function shouldProcessTextJson (asset) {
  return ['textResponses', 'textFrequency'].includes(asset.asset_type) &&
    asset.responses &&
    asset.responses.answers === undefined
}

export function processQuestion (question) {
  var assetArr = processAssets(question.payload.assets)
  question.payload.assets = {}
  forEach(assetArr, function (a) {
    question.payload.assets[a[0]] = a[1]
  })

  let answer = question.payload.answer || ''
  if (question.payload.answer && question.payload.answer.trim().length > 0 && !question.payload.answer.includes('Key Insights')) {
    answer = '<b>Key Insights:</b><br />' + answer
  }
  if (question.payload.description && question.payload.description.trim().length > 0) {
    if (answer.length > 0) answer += '<br /><br />'
    answer += '<b>Concept Description:</b><br />'
    answer += question.payload.description
    delete question.payload.description
  }
  if (question.payload.additional_info && question.payload.additional_info.trim().length > 0) {
    if (answer.length > 0) answer += '<br /><br />'
    answer += '<b>Additional Information:</b><br />'
    answer += question.payload.additional_info
    delete question.payload.additional_info
  }
  question.payload.answer = answer
}

export function assetDataType (asset) {
  var givenType = asset.asset_type
  if (givenType === 'viz' || givenType === '') {
    return 'Chart'
  } else if (givenType === 'viz-slice') {
    return 'VizSlice'
  } else if (givenType === 'aud-slice') {
    return 'AudSlice'
  } else if (givenType === 'data') {
    return 'Data'
  } else if (givenType === 'text-slice') {
    return 'TextSlice'
  } else if (givenType === 'textResponses' || givenType === 'textFrequency') {
    return 'Text'
  } else if (givenType === 'audio') {
    return 'Audio'
  } else if (givenType === 'video' || (asset.url && asset.url.indexOf('alpha-ux.wistia.com') !== -1)) {
    return 'Video'
  } else {
    return 'Other' // put it in an iframe
  }
}
